import Vue from 'vue'
import Popper from 'vue-popperjs'

Vue.component('Popper', Popper)
